import { render } from "./SupplierList.vue?vue&type=template&id=0237d7db&scoped=true&ts=true"
import script from "./SupplierList.vue?vue&type=script&lang=ts"
export * from "./SupplierList.vue?vue&type=script&lang=ts"

import "./SupplierList.vue?vue&type=style&index=0&id=0237d7db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0237d7db"]])

export default __exports__